<template>
  <main id="app" :class="{'map': this.$router.currentRoute.name == 'Map'}">
    <nav>
      <ul class="unstyled">
        <li class="bold"><a href="https://www.carteko.fr" class="logo"></a></li>
      </ul>
      <ul class="unstyled">
        <li class="bold"><a href="https://bordeauxgironde.cci.fr/" class="logo-cci" target="_blank"></a></li>
        <!-- <li><router-link to="/">Home</router-link></li> -->
        <li class="bold"><a href="https://www.carteko.fr/a-propos">À propos</a></li>
        <li class="bold"><a href="https://bordeauxgironde.cci.fr/questions-frequentes">FAQ</a></li>
        <!-- <li class="bold"><a href="#">FAQ</a></li> -->
        <li class="bold m-r-1"><a href="https://www.carteko.fr/nous-contacter">Nous contacter</a></li>
        <!-- <li class="bold"><a href="#">Particuliers</a></li> -->
        <li class="bold with-btn" v-if="currentUser" @click="clickProfile"><a href="#" class="btn"><div class="picto-mini picto-account"></div>Mon compte</a></li>
        <li class="bold with-btn" v-else><a href="https://app.carteko.fr" class="btn">Connexion</a></li>
        <li class="bold with-btn with-btn-secondary m-l-2" v-if="currentUser" @click="disconnect"><a href="#" class="btn btn-secondary"><div class="picto-mini picto-logout"></div>Déconnexion</a></li>
      </ul>
    </nav>
    <router-view/>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters(['getUrl', 'currentUser', 'getUid'])
  },
  mounted() {
    if (!this.currentUser) {
      let user = localStorage.getItem(`user-${this.getUid}`)
      let criteres = localStorage.getItem(`criteres-${this.getUid}`)
      if (user && criteres) {
        this.updateUser(JSON.parse(user))
        this.changeView(JSON.parse(criteres))
      }
    }
  },
  methods: {
    ...mapMutations(['goToProfile', 'updateUser', 'changeView', 'disconnecting']),
    clickProfile () {
      this.$http.get(this.getUrl + '/users/' + this.currentUser.id + '/researches')
        .then(response => {
          console.log(response)
          this.goToProfile(response.data)
        })
    },
    disconnect() {
      this.disconnecting()
      document.location.reload(true)
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/style/main.scss", "@/assets/style/icons.scss"
</style>
